import React from 'react';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import * as App from 'modules/app/App'
import * as API from 'modules/app/API';
import * as Modals from 'fw/globals/Modals'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsers, faBuilding, faUserPlus, faUserFriends } from '@fortawesome/free-solid-svg-icons'
import { faHandshake, faCalendarTimes } from '@fortawesome/free-regular-svg-icons'
import { Button } from 'fw/components';
import * as Formatting from 'fw/misc/Formatting';
import * as Notifications from 'fw/globals/Notifications';

class SponsorDashboard extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState(props);
	}

	initialState = (props) => {
		return {
			loading: true,
			title: "",
			form: {}
		};
	}

	get = () => {
		API.Biz.get('/dashboard/getSponsorDashboardInfo', {},
			{
				success: (r) => {
					this.setState((prevState, props) => ({
						loading: false,
						form: r.data
					}));
				},
				error: r => {
					this.setState({ loading: false });
				}
			});
	}

	componentDidMount() {
		if (App.context().passwordExpirationRemainingDays !== 0) {
			Modals.confirm("Your password will expire in " + App.context().passwordExpirationRemainingDays + " days. Would you like to change your password now?", () => {
				this.props.history.push('/accounts/profile#SecurityTab');
			});
		}

		App.updatePasswordExpirationRemainingDays(0);

		this.get();
	}

	renderConnectToVOBPanel = (disabled) => {
		return (
			<div className="panel panel-default">
				<div className="panel-body" style={{ padding: '5px' }}>
					{disabled ?
						<div>
							<p style={{ height: 45 }}><strong><p style={{ color: "#C6C3C3" }}>Connect</p></strong></p>
							<FontAwesomeIcon icon={faUsers} size="4x" color="#C6C3C3" className="my-icon" />
						</div>
						:
						<div>
							<p style={{ height: 45 }}><strong><a href="/sponsor/connectToVOB">Connect</a></strong></p>
							<a href="/sponsor/connectToVOB">
								<FontAwesomeIcon icon={faUsers} size="4x" color="#00A65A" className="my-icon" />
							</a>
							<br />
						</div>
					}
					<br />
					<p style={{ height: 55, fontSize: '13px' }}>Connect VOB/SDVOB's.<br />Connect to Resources</p>
				</div>
			</div>
		);
	}

	renderManageSponsorPanel = (disabled) => {
		return (
			<div className="panel panel-default">
				<div className="panel-body" style={{ padding: '5px' }}>
					{disabled ?
						<div>
							<p style={{ height: 45 }}><strong><p style={{ color: "#C6C3C3" }}>Corporate Member Information</p></strong></p>
							<FontAwesomeIcon icon={faBuilding} size="4x" color="#C6C3C3" className="my-icon" />
						</div>
						:
						<div>
							<p style={{ height: 45 }}><strong><a href="/sponsor/sponsorSetup">Corporate Member Information</a></strong></p>
							<a href="/sponsor/sponsorSetup">
								<FontAwesomeIcon icon={faBuilding} size="4x" color="#F39C12" className="my-icon" />
							</a>
							<br />
						</div>
					}
					<br />
					<p style={{ height: 55, fontSize: '13px' }}>Manage Corporate Member Profile</p>
				</div>
			</div>
		);
	}

	renderManageSponsorUsersPanel = (disabled) => {
		return (
			<div className="panel panel-default">
				<div className="panel-body" style={{ padding: '5px' }}>
					{disabled ?
						<div>
							<p style={{ height: 45 }}><strong><p style={{ color: "#C6C3C3" }}>Corporate Member Users</p></strong></p>
							<FontAwesomeIcon icon={faUserPlus} size="4x" color="#C6C3C3" className="my-icon" />
						</div>
						:
						<div>
							<p style={{ height: 45 }}><strong><a href="/sponsor/sponsorSetup?tabKey=sponsorUsers">Corporate Member Users</a></strong></p>
							<a href="/sponsor/sponsorSetup?tabKey=sponsorUsers">
								<FontAwesomeIcon icon={faUserPlus} size="4x" color="#DD4B39" className="my-icon" />
							</a>
							<br />
						</div>
					}
					<br />
					<p style={{ height: 55, fontSize: '13px' }}>Manage Users associated to this Corporate Member</p>
				</div>
			</div>
		);
	}

	requestRenewal = () => {
		const rq = {
			userId: App.context().userId,
			sponsorId: this.state.form.sponsorId
		};

		API.Sponsor.post('/sponsorSetup/requestRenewal', rq, {
			success: (r) => {
				var state = this.state;
				state.form.showExpiration = false;

				this.setState(state);
				Notifications.success(r.message);
			},
			error: (r) => {
				Notifications.error(r.error.errorMessage);
			}
		});
	}

	confirmRenewal = (e) => {
		e.preventDefault();
		Modals.confirm("An email will be sent to NVBDC notifying the intention of renewal. Would you like to proceed?",
			this.requestRenewal
		);
	}

	render() {
		if (this.state.loading)
			return null;

		const restrictedAccessTooltip = (
			<Tooltip id="restrictedAccessTooltip">
				<Row>
					<Col md={12}>
						Access restricted
                    </Col>
				</Row>
			</Tooltip>
		);

		const form = this.state.form;

		return (
			<React.Fragment>
				{form.corporateMemberName !== undefined ?
					<ContentHeader title={"Home - " + App.context().userName + " - " + form.corporateMemberName}>
					</ContentHeader> : null
				}
				<ContentBody>
					<div className="panel panel-default">
						<div className="panel-body dashboard">
							<Row>
								<Col md={12}>
									<br />
									{App.context().showMenu ?
										<React.Fragment>
											<Row className="align-items-center justify-content-center centered">
												<Col lg={3} md={6} className="text-center">
													<div className="panel panel-default">
														<div className="panel-body dashboard-top-panel" style={{ height: 45 }}>
															<FontAwesomeIcon icon={faHandshake} size="2x" />
															<span style={{ marginLeft: "15px" }}>
																{form.membershipLevelName ? form.membershipLevelName : "Not Defined"}
															</span>
														</div>
													</div>
													{App.hasPrivilege("SponsorConnectToVOBEdit") ?
														this.renderConnectToVOBPanel(false)
														:
														<OverlayTrigger placement="top" overlay={restrictedAccessTooltip}>
															{this.renderConnectToVOBPanel(true)}
														</OverlayTrigger>
													}
												</Col>
												<Col lg={3} md={6} className="text-center">
													<div className="panel panel-default">
														<div className="panel-body dashboard-top-panel" style={{ height: 45 }}>
															<FontAwesomeIcon icon={faCalendarTimes} size="2x" />
															<span style={{ marginLeft: "15px" }}>
																{form.expirationDate ? Formatting.formatDate(form.expirationDate) : "Not Defined"}
															</span>
														</div>
													</div>
													{App.hasPrivilege("SponsorSetupAccess") ?
														this.renderManageSponsorPanel(false)
														:
														<OverlayTrigger placement="top" overlay={restrictedAccessTooltip}>
															{this.renderManageSponsorPanel(true)}
														</OverlayTrigger>
													}
												</Col>
												<Col lg={3} md={6} className="text-center">
													<div className="panel panel-default">
														<div className="panel-body dashboard-top-panel" style={{ height: 45 }}>
															<FontAwesomeIcon icon={faUserFriends} size="2x" />
															<span className="text-left" style={{ marginLeft: "15px", fontSize: "12px" }}>
																<b>{form.totalUsers}</b> Users<br />
																<b>{form.pendingRegistrationUsers}</b> Pending Reg.<br />
															</span>
														</div>
													</div>
													{App.hasPrivilege("SponsorSetupAccess") ?
														this.renderManageSponsorUsersPanel(false)
														:
														<OverlayTrigger placement="top" overlay={restrictedAccessTooltip}>
															{this.renderManageSponsorUsersPanel(true)}
														</OverlayTrigger>
													}
												</Col>
											</Row>
											{form.showExpiration ?
												<Row>
													<Col className="text-center">
														{form.expirationDays === 0 ?
															<React.Fragment>
																Membership Expires Today
															</React.Fragment>
															: form.expirationDays > 0 ?
																<React.Fragment>
																	Membership Expires in {form.expirationDays}&nbsp;{form.expirationDays === 1 ? "day" : "days"}
																</React.Fragment>
																: <React.Fragment>
																	Membership Expired
															</React.Fragment>
														}&nbsp;-&nbsp;
														<Button type="button" bsStyle="link" onClick={this.confirmRenewal}>
															Request Membership Renewal
														</Button>
													</Col>
												</Row>
												: null}
										</React.Fragment>
										: null}
								</Col>
							</Row>

						</div>
					</div>
				</ContentBody>
			</React.Fragment >
		)
	}
}

export default SponsorDashboard;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/sponsorDashboard/SponsorDashboard.js